import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/auth';

/** Left-hand nav shared by Settings pages. Team is admin-only. */
export function SettingsNav(): JSX.Element {
  const { role } = useAuth();
  const cls = ({ isActive }: { isActive: boolean }) => (isActive ? 'active' : '');
  return (
    <nav className="settings-nav" aria-label="Settings">
      <NavLink to="/settings" end className={cls}>General</NavLink>
      {role === 'admin' && <NavLink to="/settings/team" className={cls}>Team</NavLink>}
    </nav>
  );
}
